module.exports = __webpack_public_path__ + "img/joom.7db0130c.png";